import React from 'react';
import { connect } from 'react-redux';
import Navigation from '../Components/Navigation';

const NavigationContainer = props => (
    <Navigation {...props} />
)

const mapStateToProps = state => {
    return {
        links: state.navigation.contentLinks
    }
}

export default connect(mapStateToProps)(NavigationContainer);